import React from 'react'

import EditBundleOfferForm from '../../modules/BundleOffer/components/EditBundleOfferForm'
export default function EditBundleOfferPage() {
  return <EditBundleOfferForm />
}
